<!-- 
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Terms & Conditions</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <article class="card-style-10 h-100 border-0">
                    <div class="card-body rounded">
                        <div class="section-box">
                            <p><strong>Effective Date:</strong> [Insert Date]</p>
                            <p><strong>Last Updated:</strong> [Insert Date]</p>
                            <p>
                                Welcome to RedMonk Wellness (“Company”, “we”, “our”, or “us”). These Terms and
                                Conditions (“Terms”) govern your access to and use of our website, wellness services, IV
                                therapy services, homecare services, consultations, memberships, and related offerings.
                            </p>
                            <p>
                                By accessing our website, booking an appointment, purchasing a service, or using any of
                                our wellness offerings, you agree to be bound by these Terms. If you do not agree,
                                please do not use our services.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-user-check"></i>
                                1. Eligibility
                            </h5>
                            <p>You must:</p>
                            <ul>
                                <li>Be at least 18 years of age; or</li>
                                <li>Use our services under the supervision and consent of a parent or legal guardian.
                                </li>
                                <span></span>
                            </ul>
                            <p>By using our services, you confirm that:</p>
                            <ul>
                                <li>The information you provide is accurate and complete.</li>
                                <li>You are medically fit to receive wellness services unless otherwise disclosed.</li>
                                <li>You understand that wellness services are not a substitute for emergency medical
                                    care.</li>
                                <span></span>
                            </ul>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-heart-pulse"></i>
                                2. Scope of Services
                            </h5>
                            <p>
                                RedMonk Wellness provides wellness and preventive care services including but not
                                limited to:
                            </p>
                            <ul>
                                <li>IV hydration therapy</li>
                                <li>Vitamin infusions</li>
                                <li>Recovery and performance therapies</li>
                                <li>Skin and aesthetic wellness services</li>
                                <li>Doctor consultations</li>
                                <li>Home wellness visits</li>
                                <li>Membership and subscription wellness programs</li>
                                <li>Nutritional and lifestyle guidance</li>
                                <span></span>
                            </ul>
                            <p>
                                Services may vary by location, medical suitability, and practitioner availability.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-notes-medical"></i>
                                3. Medical Disclaimer
                            </h5>
                            <ul>
                                <li>Our services are intended for wellness and preventive care purposes only.</li>
                                <li>Our treatments do not diagnose, treat, cure, or prevent any disease unless
                                    specifically stated by a licensed medical practitioner.</li>
                                <li>Results may vary between individuals.</li>
                                <li>Wellness therapies should not replace professional medical diagnosis or hospital
                                    treatment.</li>
                                <li>In case of a medical emergency, immediately contact emergency medical services.</li>
                                <span></span>
                            </ul>
                            <p>Clients are responsible for disclosing:</p>
                            <ul>
                                <li>Existing medical conditions</li>
                                <li>Allergies</li>
                                <li>Medications</li>
                                <li>Pregnancy status</li>
                                <li>Previous reactions to IV therapy or medications</li>
                                <span></span>
                            </ul>
                            <p>
                                Failure to disclose relevant medical information may increase treatment risks.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-stethoscope"></i>
                                4. Consultation and Medical Clearance
                            </h5>
                            <p>Certain treatments may require:</p>
                            <ul>
                                <li>Medical evaluation</li>
                                <li>Consultation with a licensed doctor</li>
                                <li>Blood tests or diagnostic screening</li>
                                <li>Signed consent forms</li>
                                <span></span>
                            </ul>
                            <p>
                                RedMonk Wellness reserves the right to refuse or discontinue treatment if deemed
                                medically unsuitable.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-calendar-check"></i>
                                5. Appointments and Bookings
                            </h5>
                            <h6>5.1 Appointment Confirmation</h6>
                            <p>Appointments are subject to:</p>
                            <ul>
                                <li>Availability</li>
                                <li>Payment confirmation</li>
                                <li>Medical suitability</li>
                                <span></span>
                            </ul>
                            <p>We reserve the right to reschedule appointments due to:</p>
                            <ul>
                                <li>Medical emergencies</li>
                                <li>Practitioner unavailability</li>
                                <li>Operational limitations</li>
                                <li>Safety concerns</li>
                                <span></span>
                            </ul>
                            <h6>5.2 Late Arrivals</h6>
                            <p>
                                Clients arriving late may receive reduced treatment time or may need to reschedule.
                            </p>
                            <h6>5.3 Home Service Access</h6>
                            <p>For home visits, clients must ensure:</p>
                            <ul>
                                <li>Safe and hygienic access to the premises</li>
                                <li>Availability during the scheduled time</li>
                                <li>Adequate space for treatment administration</li>
                                <span></span>
                            </ul>
                            <p>
                                Our professionals may refuse service if conditions are unsafe.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-credit-card"></i>
                                6. Pricing and Payments
                            </h5>
                            <p>
                                All pricing is displayed in Indian Rupees (INR) unless otherwise specified.
                            </p>
                            <p>
                                We reserve the right to modify prices without prior notice.
                            </p>
                            <p>Accepted payment methods may include:</p>
                            <ul>
                                <li>Credit/debit cards</li>
                                <li>UPI</li>
                                <li>Bank transfer</li>
                                <li>Online payment gateways</li>
                                <li>Cash where permitted</li>
                                <span></span>
                            </ul>
                            <p>
                                Full or partial advance payment may be required for certain services.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-money-bill-wave"></i>
                                7. Cancellation and Refund Policy
                            </h5>
                            <h6>7.1 Cancellation by Client</h6>
                            <ul>
                                <li>Cancellations made at least 24 hours before the appointment may be eligible for
                                    rescheduling.</li>
                                <li>Late cancellations may attract cancellation charges.</li>
                                <li>No-shows may result in forfeiture of booking amounts.</li>
                                <span></span>
                            </ul>
                            <h6>7.2 Refunds</h6>
                            <p>Refunds are generally not provided for:</p>
                            <ul>
                                <li>Completed services</li>
                                <li>Membership usage</li>
                                <li>Consumable medical products</li>
                                <li>Personalized treatments</li>
                                <span></span>
                            </ul>
                            <p>
                                Approved refunds, if applicable, may take 7–14 business days to process.
                            </p>
                            <h6>7.3 Cancellation by Company</h6>
                            <p>
                                We reserve the right to cancel or postpone services due to:
                            </p>
                            <ul>
                                <li>Medical safety concerns</li>
                                <li>Force majeure events</li>
                                <li>Operational reasons</li>
                                <li>Practitioner emergencies</li>
                                <span></span>
                            </ul>
                            <p>
                                In such cases, clients may receive rescheduling options or eligible refunds.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-id-card"></i>
                                8. Memberships and Packages
                            </h5>
                            <p>Memberships and wellness packages:</p>
                            <ul>
                                <li>Are non-transferable unless explicitly approved.</li>
                                <li>Must be used within the stated validity period.</li>
                                <li>Cannot be partially redeemed for cash.</li>
                                <li>May be subject to additional terms communicated at purchase.</li>
                                <span></span>
                            </ul>
                            <p>
                                Unused sessions after expiry may lapse without refund.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-triangle-exclamation"></i>
                                9. Risks and Consent
                            </h5>
                            <p>
                                Clients acknowledge that wellness procedures, including IV therapy, involve potential
                                risks such as:
                            </p>
                            <ul>
                                <li>Bruising</li>
                                <li>Swelling</li>
                                <li>Infection</li>
                                <li>Allergic reactions</li>
                                <li>Dizziness</li>
                                <li>Vein irritation</li>
                                <li>Side effects from vitamins or medications</li>
                                <li>Rare medical complications</li>
                                <span></span>
                            </ul>
                            <p>
                                By proceeding with treatment, clients voluntarily assume these risks and provide
                                informed consent.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-user-shield"></i>
                                10. Client Responsibilities
                            </h5>
                            <p>Clients agree to:</p>
                            <ul>
                                <li>Provide truthful medical information</li>
                                <li>Follow practitioner instructions</li>
                                <li>Maintain respectful behavior toward staff</li>
                                <li>Avoid misuse of medications or prescriptions</li>
                                <li>Use services lawfully and responsibly</li>
                                <span></span>
                            </ul>
                            <p>
                                Any abusive, threatening, or inappropriate conduct may result in refusal of service.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-copyright"></i>
                                11. Intellectual Property
                            </h5>
                            <p>All website content including:</p>
                            <ul>
                                <li>Logos</li>
                                <li>Branding</li>
                                <li>Images</li>
                                <li>Videos</li>
                                <li>Text</li>
                                <li>Designs</li>
                                <li>Service descriptions</li>
                                <li>Marketing materials</li>
                                <span></span>
                            </ul>
                            <p>
                                are owned by or licensed to RedMonk Wellness and protected under applicable intellectual
                                property laws.
                            </p>
                            <p>
                                Unauthorized reproduction or commercial use is prohibited.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-globe"></i>
                                12. Website Usage
                            </h5>
                            <p>Users must not:</p>
                            <ul>
                                <li>Attempt unauthorized access to systems</li>
                                <li>Distribute malicious software</li>
                                <li>Use the website for fraudulent purposes</li>
                                <li>Copy or scrape content without permission</li>
                                <li>Misrepresent affiliation with the Company</li>
                                <span></span>
                            </ul>
                            <p>
                                We reserve the right to suspend or terminate access for misuse.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-lock"></i>
                                13. Privacy
                            </h5>
                            <p>
                                Use of our services is also governed by our Privacy Policy.
                            </p>
                            <p>
                                By using our services, you consent to the collection and processing of personal and
                                medical information in accordance with applicable laws.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-scale-balanced"></i>
                                14. Limitation of Liability
                            </h5>
                            <p>
                                To the maximum extent permitted by law, RedMonk Wellness shall not be liable for:
                            </p>
                            <ul>
                                <li>Indirect or consequential damages</li>
                                <li>Loss of profits or opportunity</li>
                                <li>Delays beyond our control</li>
                                <li>Reactions caused by undisclosed medical conditions</li>
                                <li>Service interruptions</li>
                                <li>Third-party platform failures</li>
                                <span></span>
                            </ul>
                            <p>
                                Total liability, if any, shall not exceed the amount paid for the specific service
                                giving rise to the claim.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-handshake"></i>
                                15. Indemnification
                            </h5>
                            <p>
                                You agree to indemnify and hold harmless RedMonk Wellness, its directors, doctors,
                                staff, affiliates, and partners from claims arising out of:
                            </p>
                            <ul>
                                <li>Your misuse of services</li>
                                <li>Violation of these Terms</li>
                                <li>False medical disclosures</li>
                                <li>Negligent or unlawful conduct</li>
                                <span></span>
                            </ul>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-link"></i>
                                16. Third-Party Services
                            </h5>
                            <p>
                                Our website or services may contain links or integrations with third-party providers.
                            </p>
                            <p>We are not responsible for:</p>
                            <ul>
                                <li>Third-party content</li>
                                <li>Payment gateway failures</li>
                                <li>External websites</li>
                                <li>Third-party privacy practices</li>
                                <li></li>
                            </ul>
                            <p>
                                Use of third-party services is at your own risk.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-bolt"></i>
                                17. Force Majeure
                            </h5>
                            <p>
                                We shall not be liable for delays or failures caused by events beyond reasonable
                                control, including:
                            </p>
                            <ul>
                                <li>Natural disasters</li>
                                <li>Government restrictions</li>
                                <li>Epidemics or pandemics</li>
                                <li>Labor disruptions</li>
                                <li>Technical outages</li>
                                <li>Transportation interruptions</li>
                                <li></li>
                            </ul>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-building-columns"></i>
                                18. Governing Law and Jurisdiction
                            </h5>
                            <p>
                                These Terms shall be governed by and interpreted in accordance with the laws of India.
                            </p>
                            <p>
                                Any disputes shall be subject to the exclusive jurisdiction of the courts located in
                                Mumbai, Maharashtra.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-rotate"></i>
                                19. Changes to Terms
                            </h5>
                            <p>
                                We reserve the right to update or modify these Terms at any time.
                            </p>
                            <p>
                                Updated Terms will become effective upon publication on our website.
                            </p>

                            <p>
                                Continued use of our services constitutes acceptance of revised Terms.
                            </p>
                        </div>
                        <div class="section-box">
                            <h5>
                                <i class="fa fa-phone-volume"></i>
                                20. Contact Information
                            </h5>
                            <p>
                                For questions regarding these Terms and Conditions, please contact:
                            </p>
                            <ul class="d-flex flex-wrap row g-3">
                                <div class="col-lg-6">
                                    RedMonk Wellness
                                    <br>
                                    <br>
                                    B-36, Laxmi Business Park
                                    <br>
                                    <br>
                                    New Link Road, Andheri West
                                    <br>
                                    <br>
                                    Mumbai, Maharashtra, India
                                </div>

                                <div class="col-lg-6">
                                    <li>Email: info@redmonkwellness.com</li>
                                    <li>Phone: +91 62-62-03-03-03 </li>
                                    <li>Website: https://redmonkwellness.com</li>
                                    <span></span>
                                </div>
                            </ul>
                        </div>
                        <div class="consent-box">
                            <h5>
                                <i class="fa fa-circle-check"></i>
                                Consent Acknowledgment
                            </h5>
                            <p>
                                By using our website or booking services with RedMonk Wellness, you acknowledge that you
                                have read, understood, and agreed to these Terms and Conditions.
                            </p>
                        </div>
                        <div class="summary-box mt-4">
                            <h4>Terms & Conditions Overview</h4>
                            <p>
                                I’ve created a detailed Terms & Conditions page for RedMonk Wellness, covering:
                            </p>
                            <ul>
                                <li>IV therapy and wellness disclaimers</li>
                                <li>Appointments and refunds</li>
                                <li>Medical consent and risk disclosure</li>
                                <li>Memberships and packages</li>
                                <li>Liability limitations</li>
                                <li>Privacy and website usage</li>
                                <li>Indian jurisdiction clauses</li>
                                <span></span>
                            </ul>
                            <div class="customize-box">
                                <h5 class="mt-4">You can now customize:</h5>
                                <ul>
                                    <li>Effective dates</li>
                                    <li>Contact details</li>
                                    <li>Refund timelines</li>
                                    <li>Clinic-specific policies</li>
                                    <li></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</section> -->

<!-- PAGE TITLE================================================== -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Terms & Conditions</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <article class="card-style-10 h-100 border-0">
                    <div class="card-body rounded">

                        @for (s of sections(); track s.ID) {
                        <div class="section-box">
                            @if (s.Title) {
                            <h5>
                                <i [class]="s.IconClass"></i>
                                {{ s.DisplayOrder }}. {{ s.Title }}
                            </h5>
                            }
                            <div [innerHTML]="s.Content"></div>
                        </div>
                        }

                        @if (!loading() && !error() && !sections().length) {
                        <p class="text-center my-5">No content available.</p>
                        }
                        @if (error() && !sections().length) {
                        <p class="text-center my-5">Unable to load content right now.</p>
                        }

                        <!-- CONSENT (static) -->
                        <div class="consent-box">
                            <h5>
                                <i class="fa fa-circle-check"></i>
                                Consent Acknowledgment
                            </h5>
                            <p>
                                By using our website or booking services with RedMonk Wellness, you acknowledge that you
                                have read, understood, and agreed to these Terms and Conditions.
                            </p>
                        </div>

                        <div class="summary-box mt-4">
                            <h4>Terms & Conditions Overview</h4>
                            <p>
                                I’ve created a detailed Terms & Conditions page for RedMonk Wellness, covering:
                            </p>
                            <ul>
                                <li>IV therapy and wellness disclaimers</li>
                                <li>Appointments and refunds</li>
                                <li>Medical consent and risk disclosure</li>
                                <li>Memberships and packages</li>
                                <li>Liability limitations</li>
                                <li>Privacy and website usage</li>
                                <li>Indian jurisdiction clauses</li>
                                <span></span>
                            </ul>
                            <div class="customize-box">
                                <h5 class="mt-4">You can now customize:</h5>
                                <ul>
                                    <li>Effective dates</li>
                                    <li>Contact details</li>
                                    <li>Refund timelines</li>
                                    <li>Clinic-specific policies</li>
                                    <li></li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </article>
            </div>
        </div>
    </div>
</section>